<div
  class="rounded-full bg-default text-secondary p-1 pr-4 flex justify-between items-center gap-2 max-w-fit cursor-pointer hover:opacity-70 transition-all duration-150"
  #colorPickerContainer
  id="color-picker"
>
  <div class="w-10 h-10 rounded-full pallet-color flex justify-center items-center" [style.background-color]="color">
    <span class="material-symbols-outlined text-white scale-[0.85]"> colorize </span>
  </div>
  <span class="font-bold text-sm">{{ color | uppercase }}</span>
</div>
<input
  type="color"
  class="appearance-none rounded-full absolute -z-1 left-1 top-6 opacity-0"
  name="color-picker"
  [value]="color"
  #colorPickerInput
  (change)="onChangeColor(colorPickerInput.value)"
/>
